import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import webLogin from '@utils/weblogin';
import NFTAPI from './api';
export default {
  props: ['islogined'],
  watch: {
    islogined: function islogined(newValue) {
      console.info(newValue);
      this.loginStatus = newValue;
      if (newValue) {
        this.getNFTStatus();
      }
    }
  },
  data: function data() {
    return {
      loginStatus: false,
      bindEthereum: false
    };
  },
  methods: {
    logoutHandle: function logoutHandle() {
      console.info('logout');
      this.userInfo = null;
      this.loginStatus = false;
      this.$emit('changeLoginState', false);
      // eslint-disable-next-line no-unused-expressions
      this.$lmBus && this.$lmBus.$emit('Live-Login-Out-Handle');
    },
    getNFTStatus: function getNFTStatus() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var authData, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.info('getNFTStatus');
              authData = webLogin.getAuthentication();
              console.info('authData', authData);
              if (!(authData === null)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return NFTAPI.getNFTStatus();
            case 7:
              data = _context.sent;
              if (data.status === 200 && data.data.status === '200') {
                _this.account = data.data.data;
                if (_this.account.nft_subscribe_status === '2') {
                  // 用户订阅了即可展示入口
                  _this.bindEthereum = true;
                } else {
                  _this.bindEthereum = false;
                }
                _this.walletName = _this.account.nft_wallet_bind_addr_name;
              } else if (data.data.status === '402') {
                _this.logoutHandle();
              } else {
                // this.httpError();
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    httpError: function httpError() {
      this.toastText = '服务异常，请刷新页面后重试';
    }
  },
  created: function created() {}
};